import { useState } from 'react'
import { PageHeader, SaveCancelFooter } from '@/components/molecules'
import { Breadcrumb, Modal } from '@/components/atoms'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { CreateTierContainer } from '@/containers/ClubPlus/CreateTier/CreateTierContainer'
import { useForm, FormProvider } from "react-hook-form"
import { defaultValues } from '@/pages/ClubPlusPages/CreateTier/CreateTierSchemas'
import { useAppDispatch } from '@/store'
import { setToastNotifications } from '@/store/slices/commonSlice'
import { useIntl } from 'react-intl'
import './_createTier.scss'

export const CreateTier = () => {
  const { formatMessage } = useIntl()
  const methods = useForm({
    defaultValues: defaultValues,
    mode: 'onChange'
  })
  const [cancelModal, setCancelModal] = useState(false)
  const [draftModal, setDraftModal] = useState(false)
  const [phase, setPhase] = useState(1)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleCancelYes = () => {
    setCancelModal(false)
    navigate(ROUTES.CLUB_HOME)
  }

  const handleDraft = () => {
    setDraftModal(false)
    dispatch(setToastNotifications({ show: true, message: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DRAFT_SUCCESS' }), type: 'success' }))
    navigate(ROUTES.CLUB_HOME)
  }

  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },
            {
              href: '/campaigns/club-plus',
              label: 'Club+',
            },
            {
              href: '/campaigns/club-plus/create-tier',
              label: 'Create Tier Mexico',
            },
          ],
        }}
        id={'ast_bradcrumb'}
      />
      <PageHeader title={'Create Tier'} />
      <FormProvider {...methods}>
        <CreateTierContainer phase={phase} setPhase={setPhase} />
        <SaveCancelFooter
          handleCancel={() => setCancelModal(true)}
          nextAction={() => {
            if (phase === 3) {
              dispatch(setToastNotifications({ show: true, message: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SUCCESS_MESSAGE' }), type: 'success' }))
              navigate(ROUTES.CLUB_HOME)
            } else {
              setPhase(currentPhase => currentPhase + 1)
            }
          }}
          draftAction={() => setDraftModal(true)}
          isReview={phase === 3}
        />
      </FormProvider>
      <Modal
        showModal={cancelModal}
        isDark
        onCloseModal={() => setCancelModal(false)}
        primaryButtonText={formatMessage({ id: 'GENERAL.YES' })}
        secondaryButtonText={formatMessage({ id: 'GENERAL.NO' })}
        onClickPrimaryButton={handleCancelYes}
        onClickSecondaryButton={() => setCancelModal(false)}
        showLink={false}
        showSlot={false}
        showTertiaryButton={false}
        showSecondaryButton
        text={formatMessage({ id: 'CLUB_PLUS.TIER_CANCEL_MODAL_TEXT' })}
        title={formatMessage({ id: 'CLUB_PLUS.TIER_CANCEL_MODAL_TITLE' })}
        type="S"
        className="create-tier-modal"
        key="cancel-modal"
      />
      <Modal
        showModal={draftModal}
        isDark
        onCloseModal={() => setDraftModal(false)}
        primaryButtonText={formatMessage({ id: 'GENERAL.YES' })}
        secondaryButtonText={formatMessage({ id: 'GENERAL.NO' })}
        onClickPrimaryButton={handleDraft}
        onClickSecondaryButton={() => setDraftModal(false)}
        showLink={false}
        showSlot={false}
        showTertiaryButton={false}
        showSecondaryButton
        text={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DRAFT_TEXT' })}
        title={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DRAFT_TITLE' })}
        type="S"
        className="create-tier-modal"
        key="draft-modal"
      />
    </>
  )
}
